import useAddress from './useAddress'
import BuildingPermitModal from './Fields/IT/BuildingPermit/BuildingPermitModal'
import CadastralFieldsModal from './Fields/IT/CadastralFields/CadastralFieldsModal'
import LastHolderFieldsModal from './Fields/IT/LastHolderFields/LastHolderFieldsModal'
import HouseType from '@/containers/SubscriptionFormPageNew/Components/Address/Fields/Default/HouseType'
import ResidenceType from './Fields/Default/ResidenceType'
import TenantType from './Fields/Default/TenantType'
import AdditionalInformation from './Fields/Default/AdditionalInformation'
import StreetNumber from './Fields/Default/StreetNumber'
import StreetName from './Fields/Default/StreetName'
import Zipcode from './Fields/Default/Zipcode'
import City from './Fields/Default/City'
import Floor from './Fields/Default/Floor'
import Staircase from './Fields/Default/Staircase'
import ApartmentNumber from './Fields/Default/ApartmentNumber'
import Province from './Fields/Default/Province'
import IsResident from './Fields/Default/IsResident'
import Consumption from '@/containers/SubscriptionFormPageNew/Components/Address/Fields/Default/Consumption'
import { MultipleInputsContainer, StyledTitle } from './styled-components'
import EditAddressFields from '@/containers/SubscriptionFormPageNew/Components/Address/Fields/Default/EditAddressFields'
import FillEnergyLandscape from '@/containers/SubscriptionFormPageNew/Components/Address/Fields/Default/FillEnergyLandscape'
import EnergyLandscape from '@/containers/SubscriptionFormPageNew/Components/Address/Fields/Default/EnergyLandscape'
import ZipcodeValidationWarning from '@/containers/SubscriptionFormPageNew/Components/MeterSaveButton/ZipcodeValidationWarning'
import PulseCollapse from '@/shared/components/PulseScope/PulseCollapse'
import PulseReveal from '@/shared/components/PulseScope/PulseReveal'
import usePulseScope from '@/shared/components/PulseScope/usePulseScope'

// Note: the per-module 'Save' button has been removed. Saving is now driven by
// the global ClientTopHeader button which dispatches CLIENT_TAB_SAVE_ALL.
const Address = ({ hidden, title }) => {
  const { LocalizedAddressSearchComponent, hasZipcodeWarning, activeAddress, showAddressFields, showEnergyLandscape } =
    useAddress()
  const isPulse = usePulseScope()

  if (hidden || !LocalizedAddressSearchComponent) {
    return null
  }

  return (
    <PulseReveal trigger={activeAddress}>
      <StyledTitle $pulse={isPulse}>{title}</StyledTitle>
      <ResidenceType />
      <HouseType />
      <TenantType />
      <IsResident />
      <LocalizedAddressSearchComponent />
      <EditAddressFields />
      <PulseCollapse open={showAddressFields}>
        <MultipleInputsContainer>
          <Zipcode />
          <City />
        </MultipleInputsContainer>
      </PulseCollapse>
      <ZipcodeValidationWarning showWarning={hasZipcodeWarning} />
      <PulseCollapse open={showAddressFields}>
        <StreetNumber />
        <StreetName />
        <Province />
        <Floor />
        <Staircase />
        <ApartmentNumber />
      </PulseCollapse>
      <AdditionalInformation />
      <Consumption />
      <FillEnergyLandscape />
      <PulseCollapse open={showEnergyLandscape} scrollOnOpen={false}>
        <EnergyLandscape />
      </PulseCollapse>
      <BuildingPermitModal />
      <CadastralFieldsModal />
      <LastHolderFieldsModal />
    </PulseReveal>
  )
}

export default Address
